import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import BasicInput from "../../BasicInput";
import {
  useMainContext,
  useStationeryContext,
} from "../../../context/MainContext";
import { createNewPart } from "../../../screens/MainFrame/functions/stationery/createNewPart";
import { colors } from "../../../data/colors";

export default function CheckRow({ e, index }: stdObject) {
  const { docValues, setDocValues } = useMainContext();
  const {
    tabIndex,
    selectTicket,
    hasTicket,
    paperData,
    actives,
    selected,
    handleActive,
    assignItem,
  } = useStationeryContext();

  const rowOnclick = () => {
    return hasTicket
      ? () => {}
      : () => {
          const code =
            e.partType === 5
              ? e.code.CODTPA
              : e.partType === 13
                ? e.code.CODTAR
                : e.code;
          let numId =
            paperData.parts.find(
              (v: stdObject) => v.PARPAR === String(code) || v.NUMPAR === code,
            )?.NUMPAR ??
            createNewPart(
              {
                PARPAR: String(code),
                TIPPAR: tabIndex === 1 ? tabIndex : e.partType,
                XPAR: 0,
                YPAR: 0,
                ANCPAR: 0,
                ALTPAR: 0,
                SIZPAR: 12,
                BORPAR: 0,
                CBOPAR: colors.black,
              },
              { docValues, setDocValues },
            );
          assignItem(numId);
        };
  };

  const handleCheck = () =>
    hasTicket
      ? e.selected
        ? "1"
        : "0"
      : actives[
          paperData.parts.find(
            (v: stdObject) =>
              (v.PARPAR === String(e.code) || v.NUMPAR === e.code) &&
              v.TIPPAR === e.partType,
          )?.NUMPAR
        ];

  return (
    <tr
      style={{
        backgroundColor: hasTicket
          ? e.selected
            ? colors.white
            : colors.lightGrey
          : e.code === selected.code
            ? colors.grey
            : colors.white,
      }}
      onClick={rowOnclick}
    >
      <td valign="top" style={{ width: 20 }}>
        <BasicInput
          type={"checkbox"}
          active={e.code === "FORMNUMBER" ? !!docValues.data.FOMDOC : true}
          value={handleCheck()}
          onChange={(v: { target: { value: SetStateAction<string> } }) =>
            hasTicket
              ? selectTicket(index, !(v.target.value === "1"))
              : handleActive(e, !(v.target.value === "true"))
          }
        />
      </td>
      <td>
        {e.Icon && <e.Icon />}
        {hasTicket ? (
          <>
            <div>
              <b>{e.CODART}</b>
            </div>
            <div>{e.NOMART}</div>
          </>
        ) : (
          e.label
        )}
      </td>
    </tr>
  );
}
